import AlertTriangle from '~/components/icons/AlertTriangle.tsx';
import { DocStatusEnum } from '../../../types';
import { Box, SxProps, Tooltip, Typography } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles.ts';
import { useGetWarningMessageByStatuses } from '~/modules/identification/forms/Documents/hooks/useGetWarningMessageByStatuses.ts';

interface WarningIocnProps {
  status: DocStatusEnum[] | DocStatusEnum;
}

const WarningIocn = ({ status }: WarningIocnProps) => {
  const warningMessage = useGetWarningMessageByStatuses(status);
  if (!warningMessage) return null;

  return (
    <Tooltip
      title={
        <Box sx={[commonStyles.centerFlexContainer, { gap: 1 }] as SxProps}>
          <AlertTriangle variant="alert" size={25} aria-hidden="true" />
          <Typography variant="body2">{warningMessage}</Typography>
        </Box>
      }
    >
      <AlertTriangle stepStatus={status[0]} size={20} />
    </Tooltip>
  );
};

export default WarningIocn;
